import GlobeEuropeAfricaIcon from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid, InputAdornment, SvgIcon } from '@mui/material';
import { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';

import {
  gridSize,
  gridSizeMdLg6,
  useLoaders,
  useMapComponent,
} from '@/shared';
import { IconBtnModalMapComponent } from '@/shared/components/erp';
import {
  CustomAutocomplete,
  CustomCircularPorgress,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextField,
  SingleButton,
  TabTexLabelCustomSpace,
  TabTextLabel,
} from '@/shared/components/ui';
import {
  PromocionTablePreagenda,
} from '../forms';
import { IPreagendamiento, Naps, Agendamiento } from '@/shared/interfaces';
import { SaveFormDataPreagendamiento } from '../../interface/SaveFormDataPreagendamiento';
import TablaEquipoAdicionalComponente from '@/shared/components/ui/TablaEquipoAdicionalComponente/TablaEquipoAdicionalComponente';

type SaveFornData = SaveFormDataPreagendamiento & {};

export type ServiceAndOthersPartPreagendamientoFormProps = {
  form: UseFormReturn<SaveFornData>;
  // form: any;
  preagendamiento: IPreagendamiento;
  agendamiento?: Agendamiento;
  isCorrectingData?: boolean;
  hidePromociones?: boolean;
  readOnlyNap?: boolean;
};

const ServiceAndOthersPartPreagendamientoForm: React.FC<
  ServiceAndOthersPartPreagendamientoFormProps
> = ({ form, preagendamiento, isCorrectingData = false, hidePromociones = false, readOnlyNap = false }) => {
  ///* form ------------
  const { errors } = form?.formState || {};
  const shrink = true;

  ///* local state ------------
  const [canViewPromociones, setCanViewPromociones] = useState<boolean>(true);
  // map ------------------------
  const {
    Map,
    latLng,
    setLatLng,
    isLoadingNapsByCity,
    isRefetchingNapsByCity,
    napsByCity,
    setCurrentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: '', // replaced by coordenadasCliente
    distanciaNapKey: 'distancia',
    coordenadasCliente: preagendamiento?.coordenadas,
    enabledFetchNaps: !readOnlyNap && !!preagendamiento?.coordenadas,
  });

  ///* effects ------------

  // set images
  useEffect(() => {
    if (!preagendamiento) return;

    form.reset({
      ...form.getValues(),
      'nap': preagendamiento?.nap,
      'distancia': preagendamiento?.distancia,
      'detalle_instalacion': preagendamiento?.detalle_instalacion
    })
  }, [preagendamiento]);



  useLoaders(!readOnlyNap && (isLoadingNapsByCity || isRefetchingNapsByCity));
  if (!readOnlyNap && (isLoadingNapsByCity || isRefetchingNapsByCity || !preagendamiento?.nap))
    return null;

  return (
    <>
      {/* ================== SERVICIO ================== */}
      <TabTextLabel text="DETALLE DEL SERVICIO" />
      <>
        <CustomTextField
          name="tipo_servicio"
          label="Tipo de Servicio"
          control={form.control}
          defaultValue={form.getValues().tipo_servicio || ''}
          error={errors.tipo_servicio}
          helperText={errors.tipo_servicio?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="planLabel"
          label="Plan Internet"
          control={form.control}
          defaultValue={form.getValues().planLabel || ''}
          error={errors.planLabel}
          helperText={errors.planLabel?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="velocidad_internet"
          label="Velocidad Internet"
          control={form.control}
          defaultValue={form.getValues().velocidad_internet || ''}
          error={errors.velocidad_internet}
          helperText={errors.velocidad_internet?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />
        <CustomTextField
          name="tipo_instalacion"
          label="Tipo de Instalación"
          control={form.control}
          defaultValue={form.getValues().tipo_instalacion || ''}
          error={errors.tipo_instalacion}
          helperText={errors.tipo_instalacion?.message}
          shrink={shrink}
          size={gridSizeMdLg6}
          disabled
        />

        <CustomNumberTextField
          label="Valor Instalación"
          name="valor_instalacion"
          control={form.control}
          defaultValue={form.getValues().valor_instalacion}
          error={errors.valor_instalacion}
          helperText={errors.valor_instalacion?.message}
          size={gridSizeMdLg6}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          disabled
        />
        <CustomNumberTextField
          label="Valor Instalación IVA"
          name="valor_instalacion_iva"
          control={form.control}
          defaultValue={form.getValues().valor_instalacion_iva}
          error={errors.valor_instalacion_iva}
          helperText={errors.valor_instalacion_iva?.message}
          size={gridSizeMdLg6}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
          disabled
        />
      </>



      {/* ================== NAP ================== */}
      <>
        <TabTextLabel text="NAP" pt="42px" />
        {/* --------- coords and map --------- */}
        <>
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={12} md={11}>
              <CustomTextField
                type="coordenada"
                control={form.control}
                name="coordenadas"
                defaultValue={form.getValues().coordenadas || ''}
                size={gridSize}
                label="Coordenadas del Cliente"
                error={errors.coordenadas}
                startAdornment={
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small">
                      <GlobeEuropeAfricaIcon />
                    </SvgIcon>
                  </InputAdornment>
                }
                helperText={errors.coordenadas?.message}
                onChangeValue={(e, v) => {
                  if (isCorrectingData) return;

                  if (v) {
                    let s = e.split(',');
                    setLatLng({ lat: s[0], lng: s[1] });
                    setCurrentCoordenadas(e);
                  }

                  form.reset({
                    ...form.getValues(),
                    nap: '',
                  });
                }}
                disabled={isCorrectingData}
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <IconBtnModalMapComponent
                coords={
                  `${latLng.lat},${latLng.lng}` ||
                  `${form.getValues().coordenadas}` ||
                  ''
                }
                btnColor="info"
                showCustomMap
                customMap={
                  <Map
                    coordenadas={latLng}
                    napsByCity={napsByCity || []}
                    setLatLng={setLatLng}
                    canDragMarker={!isCorrectingData}
                  />
                }
              />
            </Grid>
          </Grid>
        </>

        {/* --------- NAP --------- */}
        {!readOnlyNap && (isLoadingNapsByCity || isRefetchingNapsByCity) ? (
          <CustomCircularPorgress />
        ) : (
          <>
            <CustomAutocomplete<Naps>
              label="NAP"
              name="nap"
              // options
              options={napsByCity || []}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().nap || ''}
              isLoadingData={isLoadingNapsByCity}
              // validation
              control={form.control}
              error={errors.nap}
              helperText={errors.nap?.message}
              onChangeRawValue={nap => {
                form.reset({
                  ...form.getValues(),
                  nap_data_nombre: nap?.nombre!,
                  distancia: nap?.distancia! as any,
                });
              }}
              size={gridSizeMdLg6}
              disableClearable
              disabled={isCorrectingData || readOnlyNap}
            />
            <CustomNumberTextField
              label="Distancia a la NAP"
              name="distancia"
              control={form.control}
              error={errors.distancia}
              helperText={errors.distancia?.message}
              defaultValue={form.getValues().distancia || ''}
              shrink={shrink}
              endAdornment={
                <InputAdornment position="end">metros</InputAdornment>
              }
              step={0.01}
              disabled={readOnlyNap}
              size={gridSizeMdLg6}
            />
          </>
        )}

        <>
          <CustomTextArea
            name="detalle_instalacion"
            label="Detalle Instalación"
            control={form.control}
            defaultValue={form.getValues().detalle_instalacion || ''}
            error={errors.detalle_instalacion}
            helperText={errors.detalle_instalacion?.message}
            shrink={shrink}
            disabled
          />
        </>
      </>

      {/* ================ promociones ================ */}
      {!hidePromociones && (
        <>
          <TabTexLabelCustomSpace
            textContent="Promociones"
            showCustomRightSpace={true}
            customRightSpace={
              <SingleButton
                newCustomButton
                startIcon={
                  canViewPromociones ? <ExpandLessIcon /> : <ExpandMoreIcon />
                }
                label={canViewPromociones ? 'OCULTAR' : 'VER MÁS'}
                variant="text"
                onClick={() => {
                  setCanViewPromociones(prev => !prev);
                }}
              />
            }
          />
          {canViewPromociones && (
            <>
              <PromocionTablePreagenda
                promociones={preagendamiento?.promociones_data!}
              />
            </>
          )}
        </>)}

      {/* ================ equipo adicional ================ */}
      {!hidePromociones && (
        <>
          <TablaEquipoAdicionalComponente
            equipos_adicionales={preagendamiento.preventa_data.equipos_adicionales ?? []}
          />

        </>

      )}

    </>
  );
};

export default ServiceAndOthersPartPreagendamientoForm;
